import { Fragment } from 'react';
import { Link } from 'react-router-dom';

// Floating glass-pill breadcrumb toggle. `items` render in order, separated by
// a divider; the active item is highlighted. Theme is inherited from the
// page wrapper's .theme-* class via CSS variables.
export default function Nav({ items = [] }) {
  return (
    <header className="nav">
      <nav className="nav-pill nav-crumb" aria-label="Site">
        {items.map((it, i) => {
          const cls = `nav-item${it.active ? ' is-active' : ''}`;
          return (
            <Fragment key={it.label}>
              {i > 0 && <span className="nav-sep" aria-hidden="true">|</span>}
              {it.to ? (
                <Link to={it.to} className={cls} aria-current={it.active ? 'page' : undefined}>
                  {it.label}
                </Link>
              ) : (
                <a href={it.href} className={cls}>{it.label}</a>
              )}
            </Fragment>
          );
        })}
      </nav>
    </header>
  );
}
